const propertyTypeMap = {
    1: 'ROOMSFROM',
    2: ['APARTMENTSFROM', 'APARTMENTFROM'],
    3: 'CAMPINGFROM',
    5: 'ROOMSFROM',
    6: 'ROOMSFROM',
    7: 'RURALHOUSEFROM',
    8: ['VILLASFROM', 'VILLAFROM'],
    9: ['BUNGALOWSFROM', 'BUNGALOWFROM'],
    10: ['CONDOMINIUMSFROM', 'CONDOMINIUMFROM'],
    11: 'ROOMSFROM',
    12: 'ROOMSFROM',
    13: 'ROOMSFROM',
    14: 'ROOMSFROM',
    15: 'ROOMSFROM',
    16: 'ROOMSFROM',
    17: 'ROOMSFROM',
    18: 'ROOMSFROM',
    19: ['TOWNHOUSESFROM', 'TOWNHOUSEFROM'],
    21: 'ROOMSFROM',
    22: ['COTTAGESFROM', 'COTTAGEFROM'],
    23: ['CHALETSFROM', 'CHALETFROM'],
    25: 'APARTMENTSFROM'
};

export default function(typeId, isPrivate = false) {
    const entity = propertyTypeMap[typeId || '1'];

    if (!_.isArray(entity)) {
        return entity;
    }

    return isPrivate ? entity[1] : entity[0];
}
